module.exports = __webpack_public_path__ + "static/logo-goop@2x-4ae2b947bebbfa387b4a5c680db4fa76.png";